export default {
    IframeLoaded: "iframe_loaded",
    Init: "init",
    WidgetOpen: "widget_open",
    WidgetClose: "widget_close",
    WidgetOffline: "widget_offline",
    SetOfflineAgents: "set_offline_agents",
    GetState: "get_state",
    ShowChatForm: "show_chat_form",
    HideChatForm: "hide_chat_form",
    RenderMessage: "render_message",
    SendMessage: "send_message",
    TypingHint: "typing_hint",
    MessageLoading: "message_loading",
    EndConversation: "end_conversation",
    AgentJoined: "agent_joined",
    BotAvatar: "bot_avatar",
    LoadMoreMessages: "load_more_messages",
    SubmitForm: "submit_form",
    EmailSendClick: "email_send_click",
    EmailSendSuccess: "email_send_success",
    EmailSendPending: "email_send_pending",
    EmailSendConfirm: "email_send_confirm",
    ChatResolved: "chat_resolved",
    StartChat: "start_chat",
    SetChatId: "set_chat_id",
    SetCookies: "set_cookies",
    ChatData: "chat_data",
    UpdateMessageId: "update_message_id",
    UpdateNewMessageCount: "update_new_message_count",
    ChatBotEnabled: "chatbot_enabled"
};
